import script from "./signFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./signFile.vue?vue&type=script&setup=true&lang=ts"

import "./signFile.vue?vue&type=style&index=0&id=b42d358e&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b42d358e"]])

export default __exports__